import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { RaceIndicator } from 'src/domains/sportsbook/webview/components/raceIndicator/RaceIndicator';
import { ExtraPlacesIcon } from 'src/domains/sportsbook/webview/components/raceIndicator/icons/ExtraPlacesIcon';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';

interface ExtraPlacesIndicatorPropsType {
    event: EventModel;
}

export const ExtraPlacesIndicator = observer('ExtraPlacesIndicator', ({ event }: ExtraPlacesIndicatorPropsType) => {
    const common = useCommon();
    const { raceCardExtraPlacesLabel } = ConfigComponents.get(common).config;

    if (raceCardExtraPlacesLabel === false) {
        return null;
    }

    const hasExtraPlacesIndicatorTag = event.getTag('extra-places-indicator');

    if (hasExtraPlacesIndicatorTag !== 'true') {
        return null;
    }

    return (
        <RaceIndicator
            size='medium'
            variant='secondary'
            label={
                <I18n
                    langKey='events.racecard.extra-places.label'
                    defaultText='Extra Places'
                />
            }
            dataTest='extra-places-indicator-race'
        >
            <ExtraPlacesIcon />
        </RaceIndicator>
    );
});
